import React from 'react';
import { Col, Row } from 'antd';
import { tutorBenefits } from '../../constants/whyTutorHouse';
import AnimatedContainer from '../../../../components/AnimatedContainer';
import LazyLoad from 'react-lazyload';
import css from './Benefits.module.scss';

const Benefits = () => {
  return (
    <div className={css.wrapper}>
      <div className="container">
        <div className={css.benefitsleft}>
          <h2 className={css.benefitsH2}>Tutor House Benefits</h2>
          <Row gutter={30} className={css.benefitList}>
            {tutorBenefits.map(el => (
              <Col xs={24} sm={12} md={12} lg={6} key={el.title}>
                <AnimatedContainer className={css.benefit} key={el.title}>
                  <div className={css.benefitHeader}>
                    <LazyLoad>
                      <img src={el.img} alt={el.title} />
                    </LazyLoad>
                    <span>{el.title}</span>
                  </div>
                  <div className={css.benefitDescription}>{el.description}</div>
                </AnimatedContainer>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
